import React from "react";
import { Box, Typography, Drawer, Stack, Divider, IconButton, CircularProgress, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { DetalleInventarioResultado } from "../ui";

/**
 * Drawer lateral con el resultado de un inventario (mismo patrón que DrawerDetalle de traspasos)
 */
const DrawerDetalleInventario = ({ open, onClose, inventario, loading, error, onRevisar }) => (
    <Drawer anchor="right" open={open} onClose={onClose}>
        <Box sx={{ width: { xs: "100vw", md: 520 }, p: { xs: 2, sm: 3 } }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            backgroundColor: "#fee",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <FactCheckIcon sx={{ color: "#cc071e", fontSize: 22 }} />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#212529", fontSize: { xs: "1.1rem", sm: "1.25rem" } }}>
                        Detalle inventario
                    </Typography>
                </Box>
                <IconButton
                    onClick={onClose}
                    size="small"
                    aria-label="Cerrar"
                    sx={{ color: "#6c757d", "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" } }}
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </IconButton>
            </Stack>

            <Divider sx={{ mb: 3 }} />

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
                    <Box sx={{ textAlign: "center" }}>
                        <CircularProgress sx={{ color: "#cc071e", mb: 2 }} />
                        <Typography sx={{ color: "#6c757d", fontSize: 14 }}>Cargando detalle...</Typography>
                    </Box>
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : !inventario ? (
                <Typography variant="body2" sx={{ color: "#6c757d", textAlign: "center", py: 6 }}>
                    Sin datos.
                </Typography>
            ) : (
                <DetalleInventarioResultado inventario={inventario} onRevisar={onRevisar} />
            )}
        </Box>
    </Drawer>
);

export default DrawerDetalleInventario;
